import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/lib/LanguageContext';
import Navbar from '@/components/smartpos/Navbar';
import Footer from '@/components/smartpos/Footer';
import JsonLd from '@/components/smartpos/JsonLd';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function SolutionLayout({
  eyebrow,
  breadcrumbLabel,
  title,
  titleHighlight,
  subtitle,
  jsonLd,
  visualSection,
  children,
  relatedSolutions = [],
  metaTitle,
  metaDescription,
  faqs
}) {
  const location = useLocation();
  const { t } = useLanguage();
  useDocumentMeta({
    title: metaTitle || `${title}${titleHighlight ? ` ${titleHighlight}` : ''} | SmartPOS`,
    description: metaDescription || subtitle,
    canonicalPath: location.pathname,
  });

  const faqLd = faqs && faqs.length > 0 ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a }
    }))
  } : null;

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: t('nav.skipContent') === 'Saltar al contenido' ? 'Inicio' : t('nav.skipContent') === 'Skip to content' ? 'Home' : t('nav.skipContent') === 'Salta al contingut' ? 'Inici' : 'Accueil', item: 'https://www.smartpos.es/' },
      { '@type': 'ListItem', position: 2, name: breadcrumbLabel, item: `https://www.smartpos.es${location.pathname}` },
    ],
  };

  return (
    <div className="min-h-screen font-body bg-[#F9FAFB] text-gray-900">
      <JsonLd data={jsonLd} />
      {faqLd && <JsonLd data={faqLd} />}
      <JsonLd data={breadcrumbLd} />
      <Navbar />

      <main id="contenido-principal">
      {/* Visual section reutilizada */}
      {visualSection}

      {/* Contenido SEO único */}
      <section className="py-14 bg-[#F9FAFB] text-gray-600">
        <div className="max-w-6xl mx-auto px-6 space-y-12">
          {children}
        </div>
      </section>
      </main>

      <Footer />
    </div>

  );

}